import { Expose } from "class-transformer";
import { Model } from "./model";
import { DynamicFieldTypes } from "@shared/enums/dynamic-field-types.enum";


export class DynamicField extends Model {
    @Expose() id?: number = 0;
    @Expose() customerClaimId?: number;
    @Expose() nameAr: string = '';
    @Expose() nameEn: string = '';
    @Expose() displayOrder: number = 0;
    @Expose() dataType: DynamicFieldTypes = DynamicFieldTypes.STRING;
    @Expose() isRequired = false;
    @Expose() isActive = true;
    @Expose() value?: string | number;
    @Expose() defaultValue?: string;
    @Expose() description?: string;
}